<template>
  <div class="pt-3">
    <TreeMenu />

    <v-tabs fixed-tabs color="primary" v-model="tab" :style="{ 'padding-left': padding }">
      <v-tab
        v-for="item in tabsNames"
        :key="item.name"
        class="mx-auto"
        @click="loadComponent(getComponent(item.name))"
      >
        {{ item.name }}
      </v-tab>
    </v-tabs>

    <v-row :style="{ width: `calc(100% - ${padding})px` }">
      <div class="container item" style="background-color: transparent" :style="{ 'padding-left': padding }">
        <component :is="currentComponent" class="mt-10 mx-2" @nameItem="handleNameItem" />
      </div>
    </v-row>
  </div>
</template>

<script>
import groups from "../../../store/groups/groups";
import TreeMenu from "./TreeMenu";
import Employees from "./Employees.vue";
import Schedules from "../Grupos/Schedules.vue";
import Models from "./Models.vue";

export default {
  components: { TreeMenu, Employees, Schedules, Models },
  data() {
    return {
      tab: this.$tc("groups.employees"), // Tab inicial
      currentComponent: "Employees", // Componente inicial
      tabsNames: [
        { name: this.$tc("groups.employees") },
        { name: this.$tc("groups.schedules") },
        { name: this.$tc("groups.models") },
      ],
    };
  },
  computed: {
    padding() {
      return groups.state.paddingNav;
    },
  },
  methods: {
    getComponent(tabName) {
      switch (tabName) {
        case this.$tc("groups.employees"):
          return "Employees";
        case this.$tc("groups.schedules"):
          return "Schedules";
        case this.$tc("groups.models"):
          return "Models";
        default:
          return null;
      }
    },
    loadComponent(component) {
      this.currentComponent = component;
    },
    emitEvent(texto) {
      this.$emit("nameItem", texto);
    },
    handleNameItem(texto) {
      console.log("Evento recibido del componente hijo:", texto);
    },
  },
};
</script>

<style scoped>
.item {
  max-width: 100%;
  padding: 0;
}
</style>
